var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFullBgEllipses(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1441,
    height: 3796,
    viewBox: "0 0 1441 3796",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14344_5622)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -93H1440V4430H0V-93Z",
    fill: "url(#paint0_linear_14344_5622)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter0_df_14344_5622)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1436.9,
    cy: 479.526,
    r: 91.661,
    transform: "rotate(-105.419 1436.9 479.526)",
    fill: "url(#paint1_linear_14344_5622)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter1_df_14344_5622)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1273.9,
    cy: 385.739,
    r: 46.6579,
    transform: "rotate(29.3493 1273.9 385.739)",
    fill: "url(#paint2_linear_14344_5622)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter2_df_14344_5622)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1345.68,
    cy: 230.681,
    r: 155.382,
    transform: "rotate(-17.936 1345.68 230.681)",
    fill: "url(#paint3_linear_14344_5622)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter3_df_14344_5622)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1440.9,
    cy: 2822.53,
    r: 91.661,
    transform: "rotate(-105.419 1440.9 2822.53)",
    fill: "url(#paint4_linear_14344_5622)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter4_df_14344_5622)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1277.9,
    cy: 2728.74,
    r: 46.6579,
    transform: "rotate(29.3493 1277.9 2728.74)",
    fill: "url(#paint5_linear_14344_5622)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter5_df_14344_5622)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1349.68,
    cy: 2573.68,
    r: 155.382,
    transform: "rotate(-17.936 1349.68 2573.68)",
    fill: "url(#paint6_linear_14344_5622)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter6_df_14344_5622)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 76.8544,
    cy: 232.112,
    rx: 135.411,
    ry: 145.377,
    transform: "rotate(-35.7826 76.8544 232.112)",
    fill: "url(#paint7_linear_14344_5622)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter7_df_14344_5622)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 86.8544,
    cy: 1622.11,
    rx: 135.411,
    ry: 145.377,
    transform: "rotate(-35.7826 86.8544 1622.11)",
    fill: "url(#paint8_linear_14344_5622)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_df_14344_5622",
    x: 1327.51,
    y: 385.217,
    width: 203.706,
    height: 203.05,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -7.87269,
    dy: 7.21663
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.92043
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.807843 0 0 0 0 0.658824 0 0 0 0 0.737255 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14344_5622"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14344_5622",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.31211,
    result: "effect2_foregroundBlur_14344_5622"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_df_14344_5622",
    x: 1209.52,
    y: 336.449,
    width: 113.67,
    height: 113.014,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -7.87269,
    dy: 7.21663
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.92043
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.807843 0 0 0 0 0.658824 0 0 0 0 0.737255 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14344_5622"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14344_5622",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.31211,
    result: "effect2_foregroundBlur_14344_5622"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_df_14344_5622",
    x: 1172.54,
    y: 72.6331,
    width: 331.186,
    height: 330.53,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -7.87269,
    dy: 7.21663
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.92043
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.807843 0 0 0 0 0.658824 0 0 0 0 0.737255 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14344_5622"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14344_5622",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.31211,
    result: "effect2_foregroundBlur_14344_5622"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_df_14344_5622",
    x: 1331.51,
    y: 2728.22,
    width: 203.706,
    height: 203.05,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -7.87269,
    dy: 7.21663
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.92043
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.807843 0 0 0 0 0.658824 0 0 0 0 0.737255 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14344_5622"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14344_5622",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.31211,
    result: "effect2_foregroundBlur_14344_5622"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_df_14344_5622",
    x: 1213.52,
    y: 2679.45,
    width: 113.67,
    height: 113.014,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -7.87269,
    dy: 7.21663
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.92043
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.807843 0 0 0 0 0.658824 0 0 0 0 0.737255 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14344_5622"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14344_5622",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.31211,
    result: "effect2_foregroundBlur_14344_5622"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_df_14344_5622",
    x: 1176.54,
    y: 2415.63,
    width: 331.186,
    height: 330.53,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -7.87269,
    dy: 7.21663
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.92043
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.807843 0 0 0 0 0.658824 0 0 0 0 0.737255 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14344_5622"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14344_5622",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.31211,
    result: "effect2_foregroundBlur_14344_5622"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_df_14344_5622",
    x: -89.0508,
    y: 86.0488,
    width: 308.81,
    height: 314.125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -12,
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.807843 0 0 0 0 0.658824 0 0 0 0 0.737255 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14344_5622"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14344_5622",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect2_foregroundBlur_14344_5622"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_df_14344_5622",
    x: -79.0508,
    y: 1476.05,
    width: 308.81,
    height: 314.125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -12,
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.807843 0 0 0 0 0.658824 0 0 0 0 0.737255 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14344_5622"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14344_5622",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect2_foregroundBlur_14344_5622"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14344_5622",
    x1: 720,
    y1: -93,
    x2: 720,
    y2: 4430,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F7FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14344_5622",
    x1: 1436.9,
    y1: 387.865,
    x2: 1436.9,
    y2: 571.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8FCFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_14344_5622",
    x1: 1273.9,
    y1: 339.081,
    x2: 1273.9,
    y2: 432.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8FCFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_14344_5622",
    x1: 1345.68,
    y1: 75.2993,
    x2: 1345.68,
    y2: 386.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8FCFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_14344_5622",
    x1: 1440.9,
    y1: 2730.86,
    x2: 1440.9,
    y2: 2914.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8FCFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_14344_5622",
    x1: 1277.9,
    y1: 2682.08,
    x2: 1277.9,
    y2: 2775.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8FCFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_14344_5622",
    x1: 1349.68,
    y1: 2418.3,
    x2: 1349.68,
    y2: 2729.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8FCFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_14344_5622",
    x1: 76.8544,
    y1: 86.735,
    x2: 76.8544,
    y2: 377.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8FCFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_14344_5622",
    x1: 86.8544,
    y1: 1476.74,
    x2: 86.8544,
    y2: 1767.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8FCFC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14344_5622"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1441,
    height: 3796,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullBgEllipses);
export default __webpack_public_path__ + "static/media/full-bg-ellipses.29df15253651c8bc5bb004632b6d2dce.svg";
export { ForwardRef as ReactComponent };